import { VERDICT_STYLES } from "@/constants/content";

export const ScoreDial = ({ score, verdict }) => {
  const r = 52;
  const c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, score ?? 0));
  const color = VERDICT_STYLES[verdict]?.ring ?? "#06B6D4";
  return (
    <div className="relative h-36 w-36 shrink-0 sm:h-40 sm:w-40" data-testid="score-dial">
      <svg viewBox="0 0 120 120" className="h-full w-full -rotate-90" role="img" aria-label={`Final validation score ${score ?? "loading"} out of 100`}>
        <circle cx="60" cy="60" r={r} fill="none" stroke="rgba(148,163,184,0.12)" strokeWidth="9" />
        <circle
          cx="60" cy="60" r={r} fill="none" stroke={color} strokeWidth="9" strokeLinecap="round"
          strokeDasharray={c} strokeDashoffset={c * (1 - pct / 100)}
          style={{ transition: "stroke-dashoffset 900ms cubic-bezier(.2,.8,.2,1), stroke 400ms", filter: `drop-shadow(0 0 6px ${color}99)` }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-mono text-3xl font-bold text-white sm:text-4xl" data-testid="score-dial-value">
          {score != null ? score.toFixed(1) : "--"}
        </span>
        <span className="text-xs text-slate-400">/ 100</span>
      </div>
    </div>
  );
};
